import { z } from "zod";

export const stampSchema = z.object({
  id: z.string(), code: z.string(), name: z.string(),
  description: z.string().nullable().optional(),
  imageKey: z.string().nullable().optional(),
  ruleType: z.string(),
  awardedAt: z.string().nullable().optional(),
  revoked: z.boolean().default(false),
});
export const visitRecordSchema = z.object({
  id: z.string(),
  visitedOn: z.string(),
  memo: z.string().nullable().optional(),
  rating: z.number().nullable().optional(),
  acquiredGoods: z.array(z.string()).default([]),
  companionsText: z.string().nullable().optional(),
  spoilerFlag: z.boolean().default(false),
  visibility: z.string(),
  verificationLevel: z.string(),
  createdAt: z.string(),
  place: z.object({ id: z.string(), name: z.string(), addressLine: z.string() }).nullable(),
  event: z.object({ id: z.string(), name: z.string() }).nullable(),
});

/** 빈 여권과 채워진 여권이 같은 스키마다 (AC-06). 배열 기본값으로 그것을 보장한다. */
export const passportSchema = z.object({
  displayName: z.string(),
  totalPlaces: z.number(),
  totalEvents: z.number(),
  visibility: z.string(),
  cities: z.array(z.object({ name: z.string(), count: z.number() })).default([]),
  monthlyActivity: z.array(z.object({ month: z.string(), count: z.number() })).default([]),
  tagActivity: z.array(z.object({ name: z.string(), count: z.number() })).default([]),
  stamps: z.array(stampSchema).default([]),
  timeline: z.array(visitRecordSchema).default([]),
  visitedMap: z.array(z.object({
    id: z.string(), name: z.string(), latitude: z.number(), longitude: z.number(),
  })).default([]),
});

/**
 * 실측: `/passport/share-card`. 집계와 브랜드 텍스트만 준다 —
 * 저작권 이미지도, 남의 사진도 들어 있지 않다 (OD-014).
 */
export const shareCardSchema = z.object({
  displayName: z.string(),
  totalPlaces: z.number(),
  totalEvents: z.number(),
  cities: z.array(z.object({ name: z.string(), count: z.number() })).default([]),
  stamps: z.array(stampSchema).default([]),
  logoText: z.string(),
});

export const visitResultSchema = z.object({
  visit: visitRecordSchema,
  awardedStamps: z.array(z.object({ code: z.string(), name: z.string() })).default([]),
  checkinId: z.string().optional(),
});
export type PassportDto = z.infer<typeof passportSchema>;
export type ShareCardDto = z.infer<typeof shareCardSchema>;
export type VisitResultDto = z.infer<typeof visitResultSchema>;
